export const siteMeta = {
  brand: "瓜链",
  brandEn: "GuaLink",
  tagline: "网红黑曝 · 发酵与病毒传播追踪",
  descriptor: "记录一条爆料从首爆到上热搜的完整链路",
  email: "info@gualian.example.com",
  workHours: "编辑值守 09:00 - 23:00",
  since: "2024",
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "事件追踪", to: "/events" },
  { label: "关于我们", to: "/about" },
];

export const footerColumns = [
  {
    title: "内容栏目",
    links: [
      { label: "实时热搜追踪榜", to: "/#ranking" },
      { label: "发酵机制图解", to: "/#stages" },
      { label: "传播路径分析", to: "/#spread" },
      { label: "典型案例", to: "/#cases" },
    ],
  },
  {
    title: "事件追踪库",
    links: [
      { label: "商业争议", to: "/events?category=商业争议" },
      { label: "带货翻车", to: "/events?category=带货翻车" },
      { label: "人设崩塌", to: "/events?category=人设崩塌" },
      { label: "情感纠纷", to: "/events?category=情感纠纷" },
    ],
  },
  {
    title: "关于瓜链",
    links: [
      { label: "品牌介绍", to: "/about" },
      { label: "内容原则", to: "/about#principles" },
      { label: "常见问题", to: "/#faq" },
      { label: "追踪简报订阅", to: "/#subscribe" },
    ],
  },
];

export const principles = [
  {
    icon: "ri-time-line",
    title: "保留信源时间戳",
    desc: "每条事件都记录 T+0 的原始出处与时间，让传播顺序可以被核对，而不是被转述改写。",
  },
  {
    icon: "ri-scales-3-line",
    title: "只记录不下结论",
    desc: "我们呈现热度、渠道与节点，不做是非判断，也不替读者决定应该相信谁。",
  },
  {
    icon: "ri-eye-off-line",
    title: "不放大未证实信息",
    desc: "对缺少原始出处的说法，会明确标注为待核实，不把它当作既成事实放进时间线。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续修正与回访",
    desc: "事件进入长尾后仍会回访数据，发现口径错误会在页面标注修订时间。",
  },
];

export const testimonials = [
  {
    quote: "做品牌舆情的时候，我最需要的就是把「什么时候开始失控」讲清楚。这里的发酵时间线基本可以直接拿来做复盘底稿。",
    author: "沈叙",
    role: "品牌公关 · 从业六年",
  },
  {
    quote: "以前看瓜只知道火了，现在会顺手看一下渠道占比，慢慢就明白为什么有些事能出圈、有些事只能在本地热一阵。",
    author: "林知夏",
    role: "内容观察者",
  },
  {
    quote: "传播解读那几段写得很克制，没有替谁下结论，但把「删评论等于二次传播」讲明白了，这个细节挺难得的。",
    author: "周行",
    role: "自媒体编辑",
  },
];

export const milestones = [
  {
    year: "2024",
    title: "从一份表格开始",
    desc: "最初只是编辑团队内部用来记录热点顺序的共享表格，用来回答「这条瓜到底是从哪冒出来的」。",
  },
  {
    year: "2025",
    title: "把顺序变成曲线",
    desc: "开始按小时记录话题量，把散落的时间点连成热度序列，第一次能直观看到陡升段和平台段。",
  },
  {
    year: "2026",
    title: "公开为追踪台",
    desc: "把观察口径整理成统一模板对外开放，形成今天的事件追踪库与热度看板。",
  },
];